import type { WalkthroughConductorSlice } from './types';

export const DEFAULT_CONDUCTOR_STATE: Pick<
  WalkthroughConductorSlice,
  'activeWalkthroughId' | 'settings' | 'activeSession'
> = {
  activeWalkthroughId: null,
  settings: null,
  activeSession: null,
};

export enum WalkthroughMode {
  BUILDER = 'BUILDER',
  RUNNER = 'RUNNER',
  PREVIEW = 'PREVIEW',
}
